import { render, staticRenderFns } from "./projectOrder.vue?vue&type=template&id=16103ce4&scoped=true"
import script from "./projectOrder.vue?vue&type=script&lang=js"
export * from "./projectOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16103ce4",
  null
  
)

export default component.exports